module.exports = __webpack_public_path__ + "img/bell.0ccdea7c.png";